module.exports = __webpack_public_path__ + "static/media/times.fe210022.svg";